/**
 * @file LoadingBackdrop.jsx
 * @author Rishikesh
 * @date 2024-10-01
 * @description loading backdrop component with a circular progress indicator.
 */
import React, { useEffect, useState } from "react";
import { Backdrop, CircularProgress } from "@mui/material";

export const LoadingBackdrop = ({
  isLoading,
  minLoadingDuration = 1000,
  ...props
}) => {
  const [minLoading, setMinLoading] = useState(false);

  useEffect(() => {
    let minLoadingTimer;

    if (isLoading) {
      setMinLoading(true);
      minLoadingTimer = setTimeout(() => {
        setMinLoading(false);
      }, minLoadingDuration);
    } else {
      if (minLoading) {
        minLoadingTimer = setTimeout(() => {
          setMinLoading(false);
        }, minLoadingDuration);
      }
    }

    return () => clearTimeout(minLoadingTimer);
  }, [isLoading, minLoadingDuration, minLoading]);

  return (
    <Backdrop
      sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1000 })}
      open={isLoading || minLoading}
      {...props}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};
